import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { map, take } from 'rxjs';
import { selectUser } from '@workspace-app/state/global';
import { LicenseAuthorizationService } from './license-authorization.service';

/**
 * Guard to protect license renewal workflow routes.
 * Only users with License.Admin permission (QCT-Admin) can access.
 */
export const licenseRenewalWorkflowGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);
  const licenseAuthService = inject(LicenseAuthorizationService);

  return store.pipe(
    select(selectUser),
    take(1),
    map((user) => {
      const canAccess = licenseAuthService.canManageRenewalWorkflows(user ?? null);
      if (!canAccess) {
        // Redirect to licenses list if not authorized
        router.navigate(['/certification/licenses']);
        return false;
      }
      return true;
    })
  );
};
